import * as React from 'react';

import type { IndividualLaborStatisticsParsed } from 'ab-viewModels/scheduleBoardLaborStatistics.viewModel';

import { moneyNormalizer } from '@acceligentllc/shared/utils/formatting';
import { round } from '@acceligentllc/shared/utils/number';

import { getColorTextClass } from 'af-utils/color.util';

interface Props {
	label: string;
	laborStatistics?: IndividualLaborStatisticsParsed;
	isTotals?: boolean;
}

const MaterialCostStatistics: React.FC<Props> = (props) => {

	const {
		label,
		laborStatistics = {} as IndividualLaborStatisticsParsed,
		isTotals = false,
	} = props;

	const { color, totalSalesMarkup = 0, totalMaterialCost = 0 } = laborStatistics;

	return (
		<div className={`statistics-carousel__office ${getColorTextClass(color, !isTotals)}`} >
			{!!label && <strong>{label}</strong>}
			<div className="statistics-carousel__stats-container">
				<div className="statistics-carousel__labor-stats">
					<span>Material Cost</span>
					<span>Sales Markup</span>
				</div>
				<div className="statistics-carousel__revenue-stats">
					<span>{totalMaterialCost !== null ? moneyNormalizer(round(totalMaterialCost), 0) : '-'}</span>
					<span>{moneyNormalizer(round(totalSalesMarkup))}</span>
				</div>
			</div>
		</div>
	);
};

export default React.memo(MaterialCostStatistics);
